import React from "react";
import { motion } from "framer-motion";
import {
  Globe,
  MagnifyingGlass,
  Boat,
  ShieldCheck,
  ChartLineUp,
  Handshake,
} from "@phosphor-icons/react";

const services = [
  {
    Icon: Globe,
    title: "Trade Coordination",
    text:
      "Execution of physical commodity contracts across selected South East Asia, South Asia, and Middle East corridors.",
  },
  {
    Icon: MagnifyingGlass,
    title: "Sourcing & Procurement",
    text:
      "Developing supplier relationships and structured procurement that protect quality and price.",
  },
  {
    Icon: Boat,
    title: "Logistics & Shipping",
    text:
      "Port-to-port coordination, freight planning, and shipping document discipline.",
  },
  {
    Icon: ShieldCheck,
    title: "Quality Assurance",
    text:
      "Pre-shipment inspection and third-party verification on critical consignments.",
  },
  {
    Icon: ChartLineUp,
    title: "Market Intelligence",
    text:
      "Continuous read on supply, demand, and price discovery within our active corridors.",
  },
  {
    Icon: Handshake,
    title: "Strategic Partnerships",
    text:
      "Long-term offtake and supply relationships with mills, refiners, and end users.",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      className="relative bg-white py-28 lg:py-36"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16 lg:mb-20">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-vynex-gold" />
            <span className="eyebrow text-vynex-emerald">Services</span>
          </div>
          <h2 className="font-display text-4xl lg:text-[56px] leading-[1.05] tracking-tight text-vynex-navy">
            Capabilities of a{" "}
            <span className="italic text-vynex-emerald">
              disciplined trading house.
            </span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-vynex-silver border border-vynex-silver">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              className="bg-white p-10 lg:p-12 group hover:bg-vynex-navy transition-colors duration-500 cursor-default"
              data-testid={`service-card-${i}`}
            >
              <div className="flex items-center justify-between mb-8">
                <s.Icon
                  size={34}
                  weight="thin"
                  className="text-vynex-emerald group-hover:text-vynex-gold transition-colors duration-500"
                />
                <span className="eyebrow text-vynex-silver group-hover:text-vynex-gold transition-colors duration-500">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display text-2xl lg:text-[26px] text-vynex-navy group-hover:text-white transition-colors duration-500">
                {s.title}
              </h3>
              <p className="mt-4 text-slate-600 group-hover:text-vynex-silver/80 leading-relaxed transition-colors duration-500">
                {s.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
